import React from 'react';
import Button from '~/common/components/CommonButton';
import { gtm, clickCtaEvent } from '~/common/utils/tracking';
import styles from './header-block.css';

const HeaderBlock = ({ title, subtitle, ctaText, ctaHref, darkBg }) => {
    return (
        <div className={`${styles.wrapper} ${darkBg ? styles['wrapper--dark'] : ''}`}>
            <div className={styles.container}>
                <h1 className={styles.header}>
                    {title}
                </h1>
                <h2 className={styles.subheader}>
                    {subtitle}
                </h2>
                {ctaHref &&
                    <Button
                        href={ctaHref}
                        modifier={styles.cta}
                        onClick={() => {
                            gtm(clickCtaEvent(ctaText, ctaHref, 'header component'));
                        }}
                    >
                        {ctaText}
                    </Button>}
            </div>
        </div>
    );
};

export default HeaderBlock;
